__turbopack_context__.v({
  "address-card": "KTkgXa_address-card",
  "address-card__content": "KTkgXa_address-card__content",
  "pdf-document-content": "KTkgXa_pdf-document-content",
  "pdf-document-content--locale-adjusted-font": "KTkgXa_pdf-document-content--locale-adjusted-font",
  "pdf-document-content-container": "KTkgXa_pdf-document-content-container",
  "visa-letter-pdf-modal-agreement": "KTkgXa_visa-letter-pdf-modal-agreement",
  "visa-letter-pdf-modal-agreement__message": "KTkgXa_visa-letter-pdf-modal-agreement__message",
  "visa-letter-pdf-modal-download": "KTkgXa_visa-letter-pdf-modal-download",
  "visa-letter-pdf-modal-download-form": "KTkgXa_visa-letter-pdf-modal-download-form",
  "visa-letter-pdf-modal-download__address-card": "KTkgXa_visa-letter-pdf-modal-download__address-card",
  "visa-letter-pdf-modal-download__address-card-content": "KTkgXa_visa-letter-pdf-modal-download__address-card-content",
  "visa-letter-pdf-modal-download__input": "KTkgXa_visa-letter-pdf-modal-download__input",
  "visa-letter-pdf-modal-download__message": "KTkgXa_visa-letter-pdf-modal-download__message",
});
